// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file common/v1/push_notifications.proto (package common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/v1/push_notifications.proto.
 */
export const file_common_v1_push_notifications: GenFile = /*@__PURE__*/
  fileDesc("CiJjb21tb24vdjEvcHVzaF9ub3RpZmljYXRpb25zLnByb3RvEgljb21tb24udjEi9gEKG1B1c2hOb3RpZmljYXRpb25EZXZpY2VUb2tlbhIXCgpwdXNoX3Rva2VuGAIgASgJSACIAQESNAoLZXhwaXJlX3RpbWUYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAGIAQESEwoGcDI1NmRoGAQgASgJSAKIAQESFQoIZW5kcG9pbnQYBSABKAlIA4gBARIlCghwbGF0Zm9ybRgGIAEoDjITLmNvbW1vbi52MS5QbGF0Zm9ybUINCgtfcHVzaF90b2tlbkIOCgxfZXhwaXJlX3RpbWVCCQoHX3AyNTZkaEILCglfZW5kcG9pbnQiZwoXUHVzaE5vdGlmaWNhdGlvblBheWxvYWQSDQoFdGl0bGUYAiABKAkSFQoIb3Blbl91cmwYAyABKAlIAYgBARIOCgRib2R5GAQgASgJSABCCQoHbWVzc2FnZUILCglfb3Blbl91cmwqeAoIUGxhdGZvcm0SGAoUUExBVEZPUk1fVU5TUEVDSUZJRUQQABIQCgxQTEFURk9STV9XRUIQARIYChRQTEFURk9STV9JT1NfU0FOREJPWBACEhAKDFBMQVRGT1JNX0lPUxADEhQKEFBMQVRGT1JNX0FORFJPSUQQBCp0ChFOb3RpZmljYXRpb25FdmVudBIRCg1FVkVOVF9VTktOT1dOEAASEgoORVZFTlRfUkVDRUlWRUQQARIQCgxFVkVOVF9PUEVORUQQAhIRCg1FVkVOVF9DTElDS0VEEAMSEwoPRVZFTlRfRElTTUlTU0VEEAQqmQEKGU5vdGlmaWNhdGlvbkdyb3VwSG93T2Z0ZW4SJwojTk9USUZJQ0FUSU9OX0dST1VQX0hPV19PRlRFTl9SQVJFTFkQABImCiJOT1RJRklDQVRJT05fR1JPVVBfSE9XX09GVEVOX09GVEVOEAESKwonTk9USUZJQ0FUSU9OX0dST1VQX0hPV19PRlRFTl9WRVJZX09GVEVOEAJCTlpMZ2l0aHViLmNvbS9lbW1lbXMvc3VwZXItY2FydC9hcHBzL3Nydi13b3JrZXIvdXRpbHMvbW9kZWxzL2NvbW1vbi92MTtjb21tb252MWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message common.v1.PushNotificationDeviceToken
 */
export type PushNotificationDeviceToken = Message<"common.v1.PushNotificationDeviceToken"> & {
  /**
   * @generated from field: optional string push_token = 2;
   */
  pushToken?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp expire_time = 3;
   */
  expireTime?: Timestamp;

  /**
   * @generated from field: optional string p256dh = 4;
   */
  p256dh?: string;

  /**
   * @generated from field: optional string endpoint = 5;
   */
  endpoint?: string;

  /**
   * @generated from field: common.v1.Platform platform = 6;
   */
  platform: Platform;
};

/**
 * Describes the message common.v1.PushNotificationDeviceToken.
 * Use `create(PushNotificationDeviceTokenSchema)` to create a new message.
 */
export const PushNotificationDeviceTokenSchema: GenMessage<PushNotificationDeviceToken> = /*@__PURE__*/
  messageDesc(file_common_v1_push_notifications, 0);

/**
 * @generated from message common.v1.PushNotificationPayload
 */
export type PushNotificationPayload = Message<"common.v1.PushNotificationPayload"> & {
  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: optional string open_url = 3;
   */
  openUrl?: string;

  /**
   * @generated from oneof common.v1.PushNotificationPayload.message
   */
  message: {
    /**
     * @generated from field: string body = 4;
     */
    value: string;
    case: "body";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message common.v1.PushNotificationPayload.
 * Use `create(PushNotificationPayloadSchema)` to create a new message.
 */
export const PushNotificationPayloadSchema: GenMessage<PushNotificationPayload> = /*@__PURE__*/
  messageDesc(file_common_v1_push_notifications, 1);

/**
 * @generated from enum common.v1.Platform
 */
export enum Platform {
  /**
   * @generated from enum value: PLATFORM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLATFORM_WEB = 1;
   */
  WEB = 1,

  /**
   * @generated from enum value: PLATFORM_IOS_SANDBOX = 2;
   */
  IOS_SANDBOX = 2,

  /**
   * @generated from enum value: PLATFORM_IOS = 3;
   */
  IOS = 3,

  /**
   * @generated from enum value: PLATFORM_ANDROID = 4;
   */
  ANDROID = 4,
}

/**
 * Describes the enum common.v1.Platform.
 */
export const PlatformSchema: GenEnum<Platform> = /*@__PURE__*/
  enumDesc(file_common_v1_push_notifications, 0);

/**
 * @generated from enum common.v1.NotificationEvent
 */
export enum NotificationEvent {
  /**
   * @generated from enum value: EVENT_UNKNOWN = 0;
   */
  EVENT_UNKNOWN = 0,

  /**
   * @generated from enum value: EVENT_RECEIVED = 1;
   */
  EVENT_RECEIVED = 1,

  /**
   * @generated from enum value: EVENT_OPENED = 2;
   */
  EVENT_OPENED = 2,

  /**
   * @generated from enum value: EVENT_CLICKED = 3;
   */
  EVENT_CLICKED = 3,

  /**
   * @generated from enum value: EVENT_DISMISSED = 4;
   */
  EVENT_DISMISSED = 4,
}

/**
 * Describes the enum common.v1.NotificationEvent.
 */
export const NotificationEventSchema: GenEnum<NotificationEvent> = /*@__PURE__*/
  enumDesc(file_common_v1_push_notifications, 1);

/**
 * @generated from enum common.v1.NotificationGroupHowOften
 */
export enum NotificationGroupHowOften {
  /**
   * @generated from enum value: NOTIFICATION_GROUP_HOW_OFTEN_RARELY = 0;
   */
  RARELY = 0,

  /**
   * @generated from enum value: NOTIFICATION_GROUP_HOW_OFTEN_OFTEN = 1;
   */
  OFTEN = 1,

  /**
   * @generated from enum value: NOTIFICATION_GROUP_HOW_OFTEN_VERY_OFTEN = 2;
   */
  VERY_OFTEN = 2,
}

/**
 * Describes the enum common.v1.NotificationGroupHowOften.
 */
export const NotificationGroupHowOftenSchema: GenEnum<NotificationGroupHowOften> = /*@__PURE__*/
  enumDesc(file_common_v1_push_notifications, 2);

